import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const SharedScrollableDropdownActions = {
  scrollableDropdownSearch: async (_, { path, paginatorOptions, include, searchTerm, params }) => {
    return axiosRequest.
      get(path, {
        params: {
          ...paginatorOptions,
          include,
          search_term: searchTerm,
          ...params,
        },
      }).
      then(({ data }) => data).
      catch(handleError)
  },
}
